import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Header from '../../components/header/Header';
import OrganisationName from '../../components/shared/OrganisationName';
import SetTitle from '../../components/shared/SetTitle';

import BtnFeedback from '../../images/btn_feedback_1075_725.png';
import BtnEvents from '../../images/btn_events_1075_725.png';
import BtnPeople from '../../images/btn_people_1075_725.png';
import BtnVisitors from '../../images/btn_visitors_1075_725.png';
import BtnActions from '../../images/btn_actions_1075_725.png';
import BtnActionsTaken from '../../images/btn_actions_taken_1075_725.png';
import BtnRevenue from '../../images/btn_revenue.png'
import BtnSalesSummary from '../../images/btn_sales_summary.png'

class ExportsIndex extends Component {
  render() {
    const baseLicense = localStorage.license === "base"
    const type_of_organisation = localStorage.type_of_organisation || "Social Care"

    return (
      <div>
        <SetTitle title={"Exports"} />
        <Header />

        <div className="main-page">
          <h2 className="page-title">Exports</h2>
          <OrganisationName />

          <div className="widgets">

            <Link to={"/exports/events"}>
              <div className="widget exports-page" style={{ backgroundImage: `url(${BtnEvents})` }}>
                <h3 className="title">Export Events</h3>
              </div>
            </Link>

            <Link to={"/exports/feedback"}>
              <div className="widget exports-page" style={{ backgroundImage: `url(${BtnFeedback})` }}>
                <h3 className="title">Export Feedback</h3>
              </div>
            </Link>

            <Link to={"/exports/people"}>
              <div className="widget exports-page" style={{ backgroundImage: `url(${BtnPeople})` }}>
                <h3 className="title">Export People</h3>
              </div>
            </Link>

            {baseLicense && (
              <>
                <Link to={"/exports/visitors"}>
                  <div className="widget exports-page" style={{ backgroundImage: `url(${BtnVisitors})` }}>
                    <h3 className="title">Export Visitors</h3>
                  </div>
                </Link>

                {type_of_organisation === "Retail" && (
                  <>
                    <Link to={"/exports/revenue"}>
                      <div className="widget exports-page" style={{ backgroundImage: `url(${BtnRevenue})` }}>
                        <h3 className="title">Export Revenue</h3>
                      </div>
                    </Link>

                    <Link to={"/exports/sales-summary"}>
                      <div className="widget exports-page" style={{ backgroundImage: `url(${BtnSalesSummary})` }}>
                        <h3 className="title">Sales Summary</h3>
                      </div>
                    </Link>
                  </>
                )}

                <Link to={"/exports/outstanding-actions"}>
                  <div className="widget exports-page" style={{ backgroundImage: `url(${BtnActions})` }}>
                    <h3 className="title">Outstanding Actions</h3>
                  </div>
                </Link>

                <Link to={"/exports/actions-taken"}>
                  <div className="widget exports-page" style={{ backgroundImage: `url(${BtnActionsTaken})` }}>
                    <h3 className="title">Actions Taken</h3>
                  </div>
                </Link>
              </>
            )}

          </div>
        </div>

      </div>
    );
  }
}

export default ExportsIndex;
